import { ComponentFactory, ComponentFactoryResolver, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconChevronLeft } from '@dsg-tech/homefield-angular-icons';

import { BackToSearchResultsComponent } from './back-to-search-results.component';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@NgModule({
	declarations: [
		BackToSearchResultsComponent
	],
	imports: [
		CommonModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule
	],
	exports: [
		BackToSearchResultsComponent
	],
	schemas: [NO_ERRORS_SCHEMA]
})
export class BackToSearchResultsModule {
	constructor(private resolver: ComponentFactoryResolver, homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft]);
	}

	public resolveComponentFactory(): ComponentFactory<BackToSearchResultsModule> {
		return this.resolver.resolveComponentFactory(BackToSearchResultsModule);
	}
}
